module.exports = __webpack_public_path__ + "img/default_pic.b13ede8f.png";